import { Breadcrumbs, Chip, emphasize, styled } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import React from 'react';
import { AiFillHome } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const StyledBreadcrumb = styled(Chip)<{ component?: React.ElementType }>(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(theme.palette.grey[100], 0.06),
      ...theme.applyStyles?.('dark', {
        backgroundColor: emphasize(theme.palette.grey[800], 0.06),
      }),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[100], 0.12),
      ...theme.applyStyles?.('dark', {
        backgroundColor: emphasize(theme.palette.grey[800], 0.12),
      }),
    },
    ...theme.applyStyles?.('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  };
});

interface BreadcrumbProps {
  title: string;
  badge?: number | string;
  badgeColor?: string;
  parent?: string;
  label?: string;
  onBadgeClick?: React.MouseEventHandler<HTMLElement>;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  title,
  badge,
  badgeColor,
  parent,
  label,
  onBadgeClick,
}) => {
  return (
    <div className="container-fluid">
      <div className="page-header">
        <div className="row">
          <div className="col-lg-6">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <h3 style={{ marginBottom: 0 }}>{title}</h3>
              {!!badge && (
                <Chip
                  label={badge}
                  color={(badgeColor as any) || 'default'}
                  sx={{
                    height: 20,
                    marginLeft: 2,
                    cursor: onBadgeClick ? 'pointer' : 'default',
                  }}
                  onClick={onBadgeClick}
                />
              )}
            </div>
          </div>
          <div className="col-lg-6">
            <Breadcrumbs sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <StyledBreadcrumb
                component={Link}
                to="/"
                label={<AiFillHome />}
                onClick={(e) => e.preventDefault()}
              />
              {parent && <StyledBreadcrumb label={parent} />}
              <StyledBreadcrumb label={label || title} />
            </Breadcrumbs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
